import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Authen } from "../Services/Middleware/authen";
import { TOKEN_EXP } from "../Config";
import moment from "moment";
import { useDispatch } from "react-redux";
import { logout } from "../store/Slice/authSlice";
import { useEffect } from "react";
import authService from "../Services/auth.service";

const PrivatedRoutes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuth = Authen();
  useEffect(() => {
    if (isAuth) {
      const handleMouseMove = (event) => {
        const dateExpires = localStorage.getItem(TOKEN_EXP)
          ? moment(localStorage.getItem(TOKEN_EXP))
          : null;
        const dateNow = moment(new Date());
        const diffInHours = dateNow.diff(dateExpires, "minutes");
        // console.log("เวลาไม่ใช้งาน :" + diffInHours);
        if (diffInHours < 15) {
          // console.log("ใช้งานต่อ");
          localStorage.setItem(TOKEN_EXP, new Date());
        } else {
          // console.log("logOut");
          dispatch(logout()).then(() => {
            navigate("/");
          });
        }
      };
      window.addEventListener("mousemove", handleMouseMove);
    }
    // eslint-disable-next-line
  }, []);
  return isAuth ? <Outlet /> : <Navigate to="/" />;
};

export default PrivatedRoutes;
